<template>
    <component
        :is="type ? 'span' : 'div'"
        class="show-tip"
        :class="type ? 'show-tip--field' : 'show-tip--block'"
    >
        <div v-if="!type" class="admin-tip admin-tip--block">
            <span class="admin-tip__icon" aria-hidden="true"><admin-icon name="info"></admin-icon></span>
            <p class="admin-tip__text">{{ trans(module + '.' + tip) }}</p>
        </div>
        <admin-icon
            v-else
            name="help-circle"
            class="admin-tip__field-icon"
            v-tooltip="trans(module + '.' + tip)"
            :aria-label="trans(module + '.' + tip)"
            role="img"
            tabindex="0"
        ></admin-icon>
    </component>
</template>

<script>
    export default {
        props: ['tip', 'module', 'type'],
    };
</script>
